import { PUBLIC_BUCKET_PATH } from '@/constants/constant';

export const publicBucketPath = (s3Path: string): string => {
  return `${PUBLIC_BUCKET_PATH}${s3Path}`;
};
